/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 *
 * @export
 * @interface FetchCommunityFinancialsResponseFinancialSummary
 */
export interface FetchCommunityFinancialsResponseFinancialSummary {
  /**
   * Community director's first name
   * @type string
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  firstName: string
  /**
   * Community director's last name
   * @type string
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  lastName: string
  /**
   * unique identifier for the community director
   * @type number
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  actorKey: number
  /**
   * Director role name
   * @type string
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  roleName: string
  /**
   *
   * @type CashAmount
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  totalDirectorOwe: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  totalTutorsOwe: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchCommunityFinancialsResponseFinancialSummary
   */
  totalFamiliesOwe: CashAmount
}

export function FetchCommunityFinancialsResponseFinancialSummaryFromJSON(
  json: any
): FetchCommunityFinancialsResponseFinancialSummary {
  return FetchCommunityFinancialsResponseFinancialSummaryFromJSONTyped(
    json,
    false
  )
}

export function FetchCommunityFinancialsResponseFinancialSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchCommunityFinancialsResponseFinancialSummary {
  if (json === undefined || json === null) {
    return json
  }
  return {
    firstName: json['firstName'],
    lastName: json['lastName'],
    actorKey: json['actorKey'],
    roleName: json['roleName'],
    totalDirectorOwe: CashAmountFromJSON(json['totalDirectorOwe']),
    totalTutorsOwe: CashAmountFromJSON(json['totalTutorsOwe']),
    totalFamiliesOwe: CashAmountFromJSON(json['totalFamiliesOwe']),
  }
}

export function FetchCommunityFinancialsResponseFinancialSummaryToJSON(
  value?: FetchCommunityFinancialsResponseFinancialSummary | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    firstName: value.firstName,
    lastName: value.lastName,
    actorKey: value.actorKey,
    roleName: value.roleName,
    totalDirectorOwe: CashAmountToJSON(value.totalDirectorOwe),
    totalTutorsOwe: CashAmountToJSON(value.totalTutorsOwe),
    totalFamiliesOwe: CashAmountToJSON(value.totalFamiliesOwe),
  }
}
